var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[_c('div',{staticClass:"header-left"},[_c('span',{staticClass:"logo",on:{"click":_vm.goHome}},[_c('span',{staticClass:"logo-icon"},[_vm._v("⚡")]),_c('span',{staticClass:"logo-text"},[_vm._v("commit.fun")])])]),_c('div',{staticClass:"header-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }